module.exports = __webpack_public_path__ + "static/img/platformNum.941f3385.png";